import { Grid } from '@mui/material';
import { useForm } from 'react-hook-form';

import { gridSizeMdLg4, TipoRubroChoiceEnum, useCheckPermissions, useLoaders, useTableColumnsProducto, useTableFilter, useTableServerSideFiltering } from '@/shared';
import { useFetchBodegas, useFetchCategoryProductEnabled, useFetchUbicaciones, useFetchUbicacionProductosEnabled } from '@/shared/actions/erp';
import { CustomAutocomplete, GeneralTable, SearchComponente } from '@/shared/components/ui';
import { ScrollableDialogProps } from '@/shared/components/ui/Dialogs';
import { AlertSeverityEnum, CategoriaFCorporativaEnum, RubroProductDetail } from '@/shared/interfaces';
import { BODEGAS, CATEGORYPRODUCT, IUbicacionProducto, Ubicaciones } from '@/shared/interfaces/erp/inventario';
import { PermissionsEnum } from '@/auth/interfaces';
import { useEffect } from 'react';
import { useUiStore } from '@/store/ui';
import { MaterialesKey, useMaterialesUtilizadosStore } from '@/store/erp';

export type AgregarProductoModalProps = {
    open: boolean;
    onClose: () => void;
    onConfirm: () => void;
};

type RubrosClienteFormDataType = {
    categoria_producto: string;
    producto: string;
  
    fecha_vencimiento: string;
    detalle?: RubroProductDetail; // JSON
  
    iva_producto: string; // porcentaje
  
    // fk
    bodega: string;
    ubicacion: string;
    tipo_rubro: TipoRubroChoiceEnum;
};


// Solo es una solicitud de actualización - NO bloquea el flujo
const AgregarProductoModal: React.FC<AgregarProductoModalProps> = ({
    open,
    onClose,
    onConfirm,
  // preagendamiento,
}) => {
    useCheckPermissions(PermissionsEnum.api_view_ubicacionproducto);

    ///* fetch data --------------------
    // const {
    //     data: motivosRechazoPaging,
    //     isLoading: isLoadingMotivosRechazo,
    //     isRefetching: isRefetchingMotivosRechazo,
    // } = useFetchMotivosRechazo({
    //     estado: true,
    //     modulo: ModulosEnumChoice.PREAGENDAMIENTO,
    //     page_size: 100,
    // });

    const form = useForm<RubrosClienteFormDataType>()








  

  /////* local state ==============================
//   const [addProductVisible, setAddProductVisible] = useState<boolean>(false);

  /////* global state ==============================
  const setAlert = useUiStore(s => s.setAlert);
  // rubro table -------------
  const addSelectedItem = useMaterialesUtilizadosStore(
    s => s.addSelectedItemCustomKey
  );

  /////* form ==============================
  const { errors } = form?.formState;
  const watchedBodega = form.watch('bodega');
  const watchedUbicacion = form.watch('ubicacion');
  const watchedCategory = form.watch('categoria_producto');

  /////* fetch data ==============================
  const {
    data: bodegasPaging,
    isLoading: isLoadingBodegas,
    isRefetching: isRefetchingBodegas,
  } = useFetchBodegas(
    {
      page_size: 900,
    },
    open
  );
  const {
    data: ubicacionesPaging,
    isLoading: isLoadingUbicaciones,
    isRefetching: isRefetchingUbicaciones,
  } = useFetchUbicaciones(
    {
      page_size: 900,
      bodega: watchedBodega,
    },
    !!watchedBodega
  );
  const {
    data: categoryProductPaging,
    isLoading: isLoadingCategoryProduct,
    isRefetching: isRefetchingCategoryProduct,
  } = useFetchCategoryProductEnabled({
    enabled: true,
    params: {
      page_size: 900,
    },
  });

  /////* table ==============================
  // server side filters - colums table
  const { filterObject /* , columnFilters, setColumnFilters */ } =
    useTableServerSideFiltering();
  const {
    pagination,
    searchTerm,
    globalFilter,
    onChangeFilter,
    setPagination,
  } = useTableFilter();
  const { pageIndex, pageSize } = pagination;

  const {
    data: itemsDisponiblesPaging,
    isLoading: isLoadingItemsDisponibles,
    isRefetching: isRefetchingItemsDisponibles,
  } = useFetchUbicacionProductosEnabled({
    enabled: !!watchedCategory && !!watchedUbicacion,
    params: {
      page: pageIndex + 1,
      page_size: pageSize,
      ...filterObject,
      categoria_producto: watchedCategory,
      ubicacion: watchedUbicacion,
      producto: searchTerm,
    },
  });

  ///* columns ---------------------
  const { columnsCheckMovimientoInventario } = useTableColumnsProducto();


  /////* effects ==============================
  useEffect(() => {
    if (!watchedCategory || !watchedUbicacion) return;
    if (isLoadingItemsDisponibles || isRefetchingItemsDisponibles) return;

    !itemsDisponiblesPaging?.data?.count &&
      setAlert(
        true,
        'No cuenta con productos en la ubicacion seleccionada',
        AlertSeverityEnum.warning
      );
  }, [
    watchedCategory,
    watchedUbicacion,
    isLoadingItemsDisponibles,
    itemsDisponiblesPaging,
    isRefetchingItemsDisponibles,
  ]);

  useLoaders(
    isLoadingBodegas ||
    isRefetchingBodegas ||
    isLoadingUbicaciones ||
    isRefetchingUbicaciones ||
    isLoadingCategoryProduct ||
    isRefetchingCategoryProduct ||
    isLoadingItemsDisponibles ||
    isRefetchingItemsDisponibles
  );






  ///* effects --------------------
//   useLoaders(isLoadingMotivosRechazo || isRefetchingMotivosRechazo);

  return (
    <ScrollableDialogProps
      open={open}
      title="Agregar Producto"
      rejectTextBtn={"Cerrar"}
      minWidth="70%"
      onClose={() => {
        onClose();
        //formRechazo.setValue('isRejecting', false);
        // formRechazo.reset({
        //   ...formRechazo.getValues(),
        //   motivo_rechazo: '',
        //   isRejecting: false,
        // });
      }}
      onConfirm={onConfirm}
    //   confirmTextBtn="SI"
    //   cancelTextBtn="NO"

      showConfirmBtn={false}
    //   confirmVariantBtn="outlined"
      contentNode={
        <Grid item container xs={12} mb={3} spacing={3}>
            <CustomAutocomplete<BODEGAS>
                label="Bodega"
                name="bodega"
                defaultValue={form.getValues().bodega || ''}
                // options
                valueKey="nombre"
                actualValueKey="codigo"
                options={bodegasPaging?.data.data || []}
                isLoadingData={isLoadingBodegas || isRefetchingBodegas}
                disableClearable
                // errors
                control={form.control}
                error={errors.bodega as any}
                helperText={errors.bodega?.message}
                size={gridSizeMdLg4}
            />
            <CustomAutocomplete<Ubicaciones>
                label="Ubicacion"
                name="ubicacion"
                defaultValue={form.getValues().ubicacion || ''}
                // options
                valueKey="nombre"
                actualValueKey="codigo"
                options={ubicacionesPaging?.data.data || []}
                isLoadingData={
                isLoadingUbicaciones || isRefetchingUbicaciones
                }
                disableClearable
                // errors
                control={form.control}
                error={errors.ubicacion as any}
                helperText={errors.ubicacion?.message}
                size={gridSizeMdLg4}
            />
            <CustomAutocomplete<CATEGORYPRODUCT>
                label="Categoria Producto"
                name="categoria_producto"
                defaultValue={form.getValues().categoria_producto || ''}
                // options
                valueKey="nombre"
                actualValueKey="codigo"
                options={categoryProductPaging?.data.data?.filter(x=> x.codigo == "MATERIALES" || x.codigo == "EQUIPOS" ) || []}
                isLoadingData={
                  isLoadingCategoryProduct || isRefetchingCategoryProduct
                }
                disableClearable
                // errors
                control={form.control}
                error={errors.categoria_producto as any}
                helperText={errors.categoria_producto?.message}
                size={gridSizeMdLg4}
            />

            {/* ----------- table ----------- */}
            <Grid item container xs={12} spacing={3} my={2}>
                {!!watchedUbicacion && !!watchedCategory ? (
                <>
                    <Grid item xs={12} md={6}>
                    <SearchComponente
                        onChange={onChangeFilter}
                        value={globalFilter}
                        text="producto por código"
                    />
                    </Grid>

                    <Grid item xs={12}>
                    <GeneralTable<IUbicacionProducto>
                        columns={columnsCheckMovimientoInventario}
                        data={itemsDisponiblesPaging?.data?.data || []}
                        isLoading={isLoadingItemsDisponibles}
                        isRefetching={isRefetchingItemsDisponibles}
                        // // filters - server side
                        // enableManualFiltering={true}
                        // columnFilters={columnFilters}
                        // onColumnFiltersChange={setColumnFilters}
                        // // search
                        enableGlobalFilter={false}
                        // // pagination
                        pagination={pagination}
                        onPaging={setPagination}
                        rowCount={itemsDisponiblesPaging?.data?.count}
                        // // actions ========
                        enableColumnActions={true}
                        canEdit={false}
                        canAdd={true}
                        onAdd={ubicProd => {
                            const firstPrice =
                                ubicProd?.producto_data?.precios?.[0]?.precio || '0.00';

                            // const contieneSeries = ubicProd?.series?.length > 0;
                            // const { id, ...ubiProdRestante } = ubicProd;
                            addSelectedItem(
                                {
                                codigo: ubicProd?.producto_data?.id_producto!,
                                nombre: ubicProd?.producto_data?.descripcion!,
                                precioUnitario: parseFloat(firstPrice),
                                cantidad: 1,
                                total: ubicProd?.producto_data?.precios?.[0]?.precio,
                                ivaCode: "IVA 0%",
                                ivaValue: 0, // 15% de 50
                                precioLibre: true,
                                preciosDisponibles: ubicProd?.producto_data?.precios,
                                categoria_fcorporativa: CategoriaFCorporativaEnum.MATERIALESEQUIPOS,
                                },
                                MaterialesKey.selectedItems, 'codigo', false, false
                            );
                            setAlert(
                                true,
                                'Producto añadido',
                                AlertSeverityEnum.success
                            );
                        // addSelectedItem(
                        //     {
                        //     id: ubicProd?.producto_data?.id_producto,
                        //     // producto_data: ubicProd?.producto_data,
                        //     ...ubiProdRestante,
                        //     precio_1: +firstPrice,
                        //     ivaCode:
                        //         ubicProd?.producto_data?.iva ||
                        //         IVAEnumSelect.IVA_0_CODE ||
                        //         '',
                        //     ivaValue:
                        //         +(ubicProd?.iva_data?.porcentaje || 0) ||
                        //         IVAEnumSelect.IVA_0_VALUE,
                        //     cantidadUtilizada: 1,

                        //     contieneSeries,
                        //     selectedSeries: [],

                        //     bodega: watchedBodega,
                        //     ubicacion: watchedUbicacion,
                        //     },
                        //     MaterialesKey.selectedItems,
                        //     'id',
                        //     false,
                        //     true
                        // );
                        }}
                    />
                    </Grid>
                </>
                ) : null}
            </Grid>


        </Grid>
      }
    />
  );
};

export default AgregarProductoModal;
